import React from 'react'
import {Icon} from '@chakra-ui/react'

const DownIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M5.89961 22.95L7.99961 20.9L16.1996 29.1L18.4996 31.65V2.94995H21.4996V31.65L23.8496 29.1L31.9996 20.9L34.0996 22.95L19.9996 37.05L5.89961 22.95Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default DownIcon
